(() => {
  const activate = () => {
    const logoLink = document.querySelector(
      '.header__heading-link:has(.header__heading-logo), .header__heading-link'
    );
    if (!logoLink || logoLink.dataset.snfSparkleReady === 'true') return;

    logoLink.dataset.snfSparkleReady = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    requestAnimationFrame(() => {
      logoLink.classList.add('snf-logo-sparkle');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activate, { once: true });
  } else {
    activate();
  }

  document.addEventListener('shopify:section:load', activate);
})();